import { useAuth0 } from '@auth0/auth0-react';
import { faSpinnerThird } from '@fortawesome/pro-solid-svg-icons';
import FontAwesomeIcon from 'Components/Atoms/FontAwesomeIcon/FontAwesomeIcon';
import TableFixed from 'Components/Molecules/Table/TableFixed/TableFixed';
import TableBody from 'Components/Molecules/TableBody/TableBody';
import TableColumn from 'Components/Molecules/TableColumn/TableColumn';
import TableHeader from 'Components/Molecules/TableHeader/TableHeader';
import { useEffect, useMemo } from 'react';
import { connect } from 'react-redux';
import EntityHelper from 'Services/Settings/Entity/EntityHelper';
import { useTable } from 'Services/Table/TableContext';
import { fetchBusinessUnitOverviewByPagenumber } from 'Store/BusinessUnit/Actions';
import { fetchCandidateOverviewByPagenumber } from 'Store/Candidate/Actions';
import { fetchContactOverviewByPagenumber } from 'Store/Contact/Actions';
import { StoreState } from 'Store/Reducers';
import { getEntityById } from 'Store/Settings/Entities/Selectors';
import { getFieldsById } from 'Store/Settings/Fields/Selectors';
import { isEntityFilteringByEntityName, selectEntityPaginationByEntityName, selectRecordsByIdsByEntityName, selectValuesByIdsByEntityName } from 'Store/Shared/Store/Values/Selector';
import { fetchVacancyOverviewByPagenumber } from 'Store/Vacancy/Actions';
import EntityOverviewTableRow from '../EntityOverviewTableRow/EntityOverviewTableRow';
import styles from './EntityOverviewTable.module.sass';
import { useUserMetadata } from 'Services/Authentication/Auth0/Auth0Service';
import { FieldType } from 'Store/FieldManagement/PropTypes';

const EntityOverviewTable = ({
    entity, 
    fieldById, recordById,
    values,
    pagination, filters,
    isFiltering,
    ...props
}: EntityOverviewTableProps) => {
    const user_metadata = useUserMetadata();
    const fetchOverviewByPagenumber = useMemo(() => EntityHelper.fetchOverviewByPagenumber(props, entity?.name), [entity?.name]);

    const {
        state: {
            pageNumber,
            totalPageNumbers
        },
        setTotalPageNumbers,
        setPageNumber
    } = useTable();

    useEffect(() => {
        setTotalPageNumbers(pagination.total_pages);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pagination.total_pages]);

    useEffect(() => {
        console.log('isNotFiltering: ', !isFiltering);
        console.log(pagination?.pagination?.page_number);
        // if (!isFiltering && pagination?.page_number <= 1) setPageNumber(1);
        // if (!isFiltering && !pagination?.internal_pages?.[pageNumber]) setPageNumber(1);
    }, [isFiltering, pagination?.page_number]);

    useEffect(() => {
        const fetchablePageNumber = pageNumber; // + 2;
        console.log(fetchablePageNumber);
        console.log(totalPageNumbers);
        if (fetchablePageNumber < totalPageNumbers && fetchablePageNumber !== 1) {
            let finalFilters = {};
            Object.keys(filters)
                .forEach(i =>
                    finalFilters[encodeURIComponent(i)] = filters[i]
                );
            fetchOverviewByPagenumber(user_metadata?.overview?.[entity?.name], fetchablePageNumber, finalFilters);
        }
    }, [pageNumber]);

    return <>
        <TableFixed
            header={
                <TableHeader>
                    <TableColumn
                        position='fixed'
                        size='medium'
                        id='status'
                    >
                        Status
                    </TableColumn>
                    <TableColumn
                        position='fixed'
                        size='large'
                        id='name'
                        primary
                    >
                        Naam
                    </TableColumn>
                    {
                        user_metadata?.overview?.[entity?.name]?.map(i => {
                            let name;
                            switch (i) {
                                case 'owners':
                                    name = 'Intern verantwoordelijke';
                                    break;
                                case 'updated_at':
                                    name = 'Laatst geupdate op';
                                    break;
                                case 'created_at':
                                    name = 'Aangemaakt op';
                                    break;
                                default:
                                    name = fieldById?.[i]?.name;
                                    break;
                            }
        
                            const field = fieldById?.[i];
                            if (field?.type === FieldType.Combination) {
                                return <>
                                    {
                                        field
                                            ?.default
                                            ?.fields
                                            ?.map(j => {
                                                const combinationField = fieldById?.[j];
                                                return <TableColumn id={i}>
                                                    { combinationField?.name } - { field?.name }
                                                </TableColumn>
                                            })
                                    }
                                </>
                            }
        
                            return <TableColumn id={i}>
                                { name }
                            </TableColumn>
                        })
                    }
                </TableHeader>
            }
        >
            <TableBody>
                {
                    isFiltering || !pagination?.internal_pages?.[pageNumber]
                    ? <div className={styles['entityoverviewtable__filtering']}>
                        <FontAwesomeIcon icon={faSpinnerThird} />
                    </div>
                    : <>
                        {
                            pagination?.internal_pages?.[pageNumber]?.map((record_id) =>
                                <EntityOverviewTableRow
                                    entity={entity}
                                    record_id={record_id}
                                    fields={user_metadata?.overview?.[entity?.name] ?? []}
                                />
                            )
                        }
                        {
                            pagination?.internal_pages?.[pageNumber].length === 0 &&
                            <div className={styles['entityoverviewtable__not-found']}>
                                Geen resultaten gevonden...
                            </div>
                        }
                    </>
                }
            </TableBody>
        </TableFixed>
    </>;
}

interface Props {
    entity_id: string,
    filters: any
}

const mapState = (state: StoreState, props: Props) => ({
    entity: getEntityById(state, props.entity_id),

    fieldById: getFieldsById(state),

    recordById: selectRecordsByIdsByEntityName(state, getEntityById(state, props.entity_id)?.name),
    values: selectValuesByIdsByEntityName(state, getEntityById(state, props.entity_id)?.name),

    pagination: selectEntityPaginationByEntityName(state, getEntityById(state, props.entity_id)?.name),
    isFiltering: isEntityFilteringByEntityName(state, getEntityById(state, props.entity_id)?.name)
});

const mapDispatch = {
    fetchVacancyOverviewByPagenumber,
    fetchCandidateOverviewByPagenumber,
    fetchBusinessUnitOverviewByPagenumber,
    fetchContactOverviewByPagenumber,
};

type EntityOverviewTableProps = Props & ReturnType<typeof mapState> & typeof mapDispatch;

export default connect(mapState, mapDispatch)(EntityOverviewTable);